var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "submenus"
  }, [_c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.wines
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.wines ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Wines")])])]), _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.spirits
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.spirits ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Spirits")])])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };